import { apiSlice } from "../apiSlice";

const TESTING_ENVIRONMENT_BASE_URL = process.env.REACT_APP_SLDL_TESTING_ENVIRONMENT_API_BASE_URL;

export const userService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getSingleUser: builder.mutation({
            query: ({ userId }) => {
                const url = `${TESTING_ENVIRONMENT_BASE_URL}user/getUser?userId=${encodeURIComponent(
                    userId
                )}`;
                return {
                    url,
                    method: "GET",
                    responseHandler: (response) => response.json(),
                };
            },
        }),

        getAllUsers: builder.mutation({
            query: () => ({
                url: `${TESTING_ENVIRONMENT_BASE_URL}user/getAllUsers`,
                method: "GET",
                responseHandler: (response) => response.json(),
            }),
        }),

        addUser: builder.mutation({
            query: (data) => ({
                url: `${TESTING_ENVIRONMENT_BASE_URL}user/addUser`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),

        userSignup: builder.mutation({
            query: (data) => ({
                url: `${TESTING_ENVIRONMENT_BASE_URL}auth/signup`,
                method: "POST",
                body: data,
            }),
        }),

        userSignIn: builder.mutation({
            query: (data) => ({
                url: `${TESTING_ENVIRONMENT_BASE_URL}auth/login`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            }),
        }),

        socialLogin: builder.mutation({
            query: (data) => ({
                url: `${TESTING_ENVIRONMENT_BASE_URL}auth/social-login`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            }),
        }),
    }),
});

export const {
    useAddUserMutation,
    useUserSignupMutation,
    useUserSignInMutation,
    useSocialLoginMutation,
} = userService;
